// extracted by mini-css-extract-plugin
export default {"main_bg":"MainBLock_main_bg__LVmCS","mainContainer":"MainBLock_mainContainer__o5lmd","title":"MainBLock_title__Q5otY","sub":"MainBLock_sub__2Wg6X","button":"MainBLock_button__URsVb"};